<template>
  <ion-page>
    <master-layout pageTitle="لیست آدرس ها">
      <Loading :is="!loaded" v-if="!loaded"></Loading>
      <div v-if="loaded">
      <ion-card>
        <ion-card-content>
          <router-link to="/Address/Add" >
            <ion-button color="medium">افزودن آدرس جدید</ion-button>
            </router-link>
          <DataTable :headers="headers" :datas="data"></DataTable>
        </ion-card-content>
      </ion-card>
      </div>
    </master-layout>
  </ion-page>
</template>

<script>
import DataTable from "@/components/DataTable";
import {
  alertController,
  IonCard, IonCardContent, IonPage
} from "@ionic/vue";
import {mapActions} from "vuex";
import {showSystemNoti} from "@/shared/helper";

export default {
  data()
  {
    return {
      id: null,
      data : [],
      loaded : false,
      functions:[
        {name : 'deleteAddress',method: this.deleteAddress}
      ],
      headers: [
        'عنوان',
        'پیش فرض',
        'امکانات'
      ]
    };
  },
  async created()
  {

  },
  async mounted()
  {
    await this.init();
  },
  methods:{
    ...mapActions("address",{
      getAddresses : 'getAddresses',
      addressDelete : 'addressDelete'
    }),
    async init()
    {
      this.loaded = false;
      this.data = [];
      const addresses_obj = await this.getAddresses();
      if (addresses_obj && addresses_obj.ok)
      {
        const addresses = addresses_obj.addresses;
        const data = [];
        for (let i = 0; i < addresses.length; i++)
        {
          const a = addresses[i];
          const btn = '<router-link to="/Address/Edit/'+a._id+'" >' +
              '<ion-button color="tertiary"><i class="far fa-edit"></i></ion-button>' +
              '</router-link>' +
              '<ion-button class="method" data-name="deleteAddress" data-params="'+a._id+'|salam" color="danger"><i class="far fa-trash"></i></ion-button>';
          data.push([a.title,a.default?'هست':'نیست',btn]);
        }
        this.data = data;
      }
      this.loaded = true;
    },
    async deleteAddress (id)
    {
      const alert = await alertController
          .create({
            cssClass: 'my-custom-class',
            header: 'آیا اطمینان دارید!',
            message: 'آدرس حذف شود.',
            buttons: [
              {
                text: 'لفو',
                role: 'cancel',
                cssClass: 'danger',
                handler: blah =>
                {
                  console.log('Confirm Cancel:', blah)
                },
              },
              {
                text: 'تایید',
                handler: async () =>
                {
                  const check = await this.addressDelete(id);
                  if (check.ok)
                  {
                    return showSystemNoti('success',check.message);
                  }
                  else
                    return showSystemNoti('success',check.error);
                },
              },
            ],
          });
      return alert.present();
    },
  },
  components: {
    IonCard, IonCardContent, DataTable, IonPage
  },
  watch: {
    "$route.path": {
      handler(newUrl)
      {
        if (newUrl.toLowerCase().indexOf('address/list') >= 0)
        {
          this.init()
        }
      },
      deep : true,
    },
  }
};
</script>

<style scoped>

</style>